module.exports = __webpack_public_path__ + "img/daimakuai.7b3e2647.png";